import { render, staticRenderFns } from "./WebSocket.vue?vue&type=template&id=9b1e4852&"
import script from "./WebSocket.vue?vue&type=script&lang=js&"
export * from "./WebSocket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports